// extracted by mini-css-extract-plugin
module.exports = {"btnTopo":"SolicitacaoDeColeta_btnTopo__1dMDj","content":"SolicitacaoDeColeta_content__2Lyvd","th_tr_Responsive":"SolicitacaoDeColeta_th_tr_Responsive__bQBOi"};